import { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { makeStyles, Paper } from "@material-ui/core";
import { CloudUpload } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(1),
        position: 'relative',
    },
    helpText: {
        display: 'flex',
        position: 'relative',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        top: 0,
        left: 0,
        marginTop: theme.spacing(1),
        width: '100%',
        height: '100%',
        '& p': {
            marginTop: theme.spacing(0.5),
        }
    }
}))
export default function MultiFileUpload({ onAdd }) {
    const classes = useStyles();
    const onDrop = useCallback(acceptedFiles => {
        onAdd(acceptedFiles)
    }, [onAdd])
    const { getRootProps, getInputProps } = useDropzone({ onDrop })
    // using it as computed property to avoid flickering


    return (
        <div>
            <Paper variant="outlined" className={classes.paper} {...getRootProps()} >
                <input {...getInputProps()} />
                <div className={classes.helpText}>
                    <CloudUpload />
                    <p>Drag 'n' drop some files here, or click to select files</p>
                </div>
            </Paper>
        </div>
    )
}